<template>
<div>
  <div class="largeScreen">
    <!-- 头部 -->
    <div class="top">
      <div class="topVue">
        <div class="left">
        <!-- <span>综合治理中心</span>   @click="goHome"-->
        </div>
        <div class="center title">
          小平房村数字乡村综合治理与服务中心
        </div>
        <div class="right">
            <span>{{nowTime}}</span>
            <span></span>
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="cont">
    <!-- 左侧 -->
    <div class="contLeft">
      <div class="CL_title bigTitle">
        <div class="beforeSpanBox"> 
            <span class="beforeSpan beforeSpan3"></span>
            <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
            <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
        </div>
        <span >人员统计分析</span>
        <span class="afterSpan fade-enter-active fade-enter-to"> </span>
      </div>
    <div class="CL_cont">
        <div class="CL_cont1">
          <div class="smallTitle">
            <span class="fade3 fade3-leave-active fade3-leave-to"></span>
            男女分布比例
          </div>
          <div class="smallCont">
              <div class="sexVue">
                  <div class="sexLegend">
                    <div class="sexBox">
                        <span>|</span>
                        <div> 
                          <span class="sexNum">{{baseParams.woman}}</span>
                          <span class="sexLabel">女性（人）</span>
                        </div>
                    </div>
                    <div class="sexBox">
                     <span>|</span>
                        <div> 
                          <span class="sexNum">{{baseParams.man}}</span>
                          <span class="sexLabel">男性（人）</span>
                        </div>
                    </div>
                  </div>
                  <div class="sexEcharts">
                    <span class="woman" :style="{width: baseParams.womanPer + '%'}">
                      <div class="womanDiv"></div>
                      <div class="womanDialog">
                          <span>女性</span>
                          <span>{{baseParams.woman}}人 | {{baseParams.womanPer}}%</span>
                      </div>
                    </span>
                    <span class="man" :style="{width: baseParams.mansPer + '%'}">
                      <div class="manDiv"></div>
                      <div class="manDialog">
                          <span>男性</span>
                          <span>{{baseParams.man}}人 | {{baseParams.mansPer}}%</span>
                      </div>
                    </span>
                  </div>
              </div>
          </div>
        </div>
        <div class="CL_cont2">
          <div class="smallTitle">
            <span class="fade3 fade3-leave-active fade3-leave-to"></span>
            人口户籍分布
          </div>
          <div class="smallCont">
            <div class="population">
            <div class="renkou" ref="renkou" style="width:100%;height:100%"></div>
            </div>
          </div>
        </div>
        <div class="CL_cont3">
          <div class="smallTitle">
          <span class="fade3 fade3-leave-active fade3-leave-to"></span>
            年龄分布比例
          </div>
          <div class="smallCont">
            <div class="ageVue">
              <div class="echartsBg">
                <span class="span1"></span>
                <span class="span2"></span>
                <span class="span3"></span>
                <span class="span4"></span>
              </div>
              <div  class="circle" ref="circle" style="width:100%;height:100%;border: 1px solid transparent;-webkit-tap-highlight-color: transparent;user-select: none;"></div>

            </div>
          </div>
        </div>
    </div>

    </div>
    <!-- 中间 -->
    <div class="contCenter">
        <div class="CC_top"> 
            <div class="mapCont">
              <div class="info allInfo">
              <div class="infoTitle">党委</div>
              <div class="infoCont">
              <div style="margin-bottom: 0.15rem" v-for="(item,index) in morePeoples" :key="index">
                   <div style="font-size: .3rem;color: #fac858;font-family:'HuXiaoBoNanShenTi'">{{item.branchName }}</div>
                    <div style="margin: 0.1rem 0;font-size: 0.3rem;color: #fac858;">{{item.memberNums||0 }}人</div>
                     <!-- v-if="item.secretaryName" -->
                    <div >支部书记：{{item.secretaryName }}</div>
              </div>
              </div>
              </div>
              <div class="mapCss mapCity">
                <div ref="mapBox" style="width:90%;height:100%"> </div>
              
              </div>
              <div class="info allInfo">
                <div class="infoTitle">村委</div>
                
              <div class="infoCont cunInfo">
              <!-- width: 100%;align-items: center; -->
              <div style="display: flex; align-items: center;justify-content: flex-start;width:100%">
                  <div class="infoCount_item" style="margin-top:0.8rem;align-items: center" v-for="(item,index) in peopleList1" :key="index">
                        <img style="width:100%;height:100%"  :src="item.avatarUrl" />
                        <div>
                        <div style="font-size:0.2rem;text-align:center">{{item.memberName }}</div>
                        <div class="overflow-ellipsis-multiline" style="text-align:center">{{item.positionName }}</div>
                        </div>
                  </div>
              </div>
              <div class="infoCount_item" v-for="(item,index) in peopleList" :key="index" v-if="item.avatarUrl&&item.memberName!='钱学余'&&item.memberName!='李永刚'">
                <!-- <template v-if="item.avatarUrl"> -->
                    <img style="width:100%;height:100%" :src="item.avatarUrl" />
                    <div>
                    <div style="font-size:0.2rem;text-align:center">{{item.memberName }}</div>
                    <div class="overflow-ellipsis-multiline" style="text-align:center">{{item.positionName }}</div>
                    </div>
                  <!-- </template> -->
              </div>
              </div>
              </div>
            </div>
        </div>
        <div class="CC_Bottom">
          <div class="CCB1">
            <div class="CCB_title bigTitle">
              <div class="beforeSpanBox"> 
                  <span class="beforeSpan beforeSpan3"></span>
                  <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
                  <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
              </div>
              <span >农业产业数据分析</span>
              <span class="afterSpan fade-enter-active fade-enter-to"> </span>
            </div>
            
              <div class="CCBCont">
                  <div class="energyStatistics">
                    <div class="left">
                      <div class="leftbox">
                          <div class="lb_left">
                            <span :class="zhong?'active':''">种植</span>
                          </div>
                          <div class="lb_right">
                            <span>137.35</span>
                            <span>万斤</span>
                          </div>
                      </div>
                      <div class="leftbox">
                        <div class="lb_left">
                              <span :class="yang?'active':''">养殖</span>
                            </div>
                            <div class="lb_right">
                              <span>439.67</span>
                              <span>万元</span>
                            </div>
                      </div>
                    </div>
                    <div class="right">
                      <div ref="linenew" style="width:100%;height:100%"></div>
                    </div>
                  </div>
              </div>
          </div>
          <div class="CCB2">
            <div class="CCB_title bigTitle">
              <div class="beforeSpanBox"> 
                  <span class="beforeSpan beforeSpan3"></span>
                  <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
                  <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
              </div>
              <span >工业产业数据分析</span>
              <span class="afterSpan fade-enter-active fade-enter-to"> </span>
            </div>
             <div class="CCBCont">
                  <div class="energyStatistics">
                    <div class="left">
                      <div class="leftbox">
                          <div class="lb_left">
                            <span :class="kuang?'active':''">工矿</span>
                          </div>
                          <div class="lb_right">
                            <span>11000</span>
                            <span>万元</span>
                          </div>
                      </div>
                      <div class="leftbox">
                        <div class="lb_left">
                              <span :class="!kuang?'active':''">企业</span>
                            </div>
                            <div class="lb_right">
                              <span>3650</span>
                              <span>万元</span>
                            </div>
                      </div>
                    </div>
                    <div class="right">
                      <div ref="linenew1" style="width:100%;height:100%"></div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <!-- 右侧 -->
    <div class="contRight">
      <div class="CR1">
        <div class="CR_title bigTitle">
              <div class="beforeSpanBox"> 
                  <span class="beforeSpan beforeSpan3"></span>
                  <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
                  <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
              </div>
              <span >荣誉资质</span>
              <span class="afterSpan fade-enter-active fade-enter-to"> </span>
          </div>

          <div class="CR_cont">
            <div class="content">
                <div><img src="./assets/img/rong/1.png"/></div>
                <div><img src="./assets/img/rong/2.png"/></div>
                <div><img src="./assets/img/rong/3.png"/></div>
                <div><img src="./assets/img/rong/4.png"/></div>
                <div><img src="./assets/img/rong/5.png"/></div>
                <div><img src="./assets/img/rong/6.png"/></div>
                <!-- <div><img src="./assets/img/rong/7.png"/></div> -->
            </div>
          </div>
      </div>
      <div class="CR2">
          <div class="CR_title bigTitle">
              <div class="beforeSpanBox"> 
                  <span class="beforeSpan beforeSpan3"></span>
                  <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
                  <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
              </div>
              <span >网格员</span>
              <span class="afterSpan fade-enter-active fade-enter-to"> </span>
          </div>
          <div class="CCBCont">
            <div class="abnormalAlarm">
              <div class="realData">
              <el-table :data="zpajList" style="width: 100%;" height="5.7rem" ref="tab" id="boxed">
                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="fullName" label="姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="mobile" label="联系电话" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="areaManagementName" label="管辖片区" width="150" align="center">
                    </el-table-column>
              </el-table>
              </div>
            </div>
          </div>
      </div>
      <div class="CR3">
          <div class="CR_title bigTitle">
              <div class="beforeSpanBox"> 
                  <span class="beforeSpan beforeSpan3"></span>
                  <span class="beforeSpan beforeSpan1 fade1-leave-active fade1-leave-to"></span>
                  <span class="beforeSpan beforeSpan2 fade2-leave-active fade2-leave-to"></span>
              </div>
              <span >服务业产业数据分析</span>
              <span class="afterSpan fade-enter-active fade-enter-to"> </span>
          </div>
          <div class="CCBCont">
                  <div class="energyStatistics">
                    <div class="left">
                      <div class="leftbox">
                          <div class="lb_left">
                            <span class="active">旅游</span>
                          </div>
                          <div class="lb_right">
                            <span>218</span>
                            <span>万元</span>
                          </div>
                      </div>
                      <div class="leftbox" style="background:none"></div>
                    </div>
                    <div class="right">
                      <div ref="linenew2" style="width:100%;height:100%"></div>
                    </div>
                  </div>
              </div>
            </div>
      </div>
    </div>
    
    </div>

  </div>
</div>
</template>
<script>
import { getNowTime, getID } from '@/utils/index.js'
import * as echarts from 'echarts'
import { barOptions, circleOption, newlineOption, mapOption } from './utils/options.js'
import { getAllGrids, getOthers, getAllRatio, getAllMembers, getDangArea } from '@/api/api.js'
import { setInterval } from 'timers'
const mapData = require('@/utils/cun.json')

export default {
  data() {
    return {
      year: '',
      timer: '', //定义一个定时器
      nowTime: '',
      rolltimer: '',
      zpajList: [],
      dataList: [],
      data1List: [],
      data2List: [],
      linetimer: '',
      gtimer: '',
      ftimer: '',
      zhong: false,
      yang: false,
      kuang: false,
      baseParams: {},
      peopleList: [],
      peopleList1:[{
        "id": 1,
    "memberName": "钱学余",
    "avatarUrl": "https://xiaopingfang.baize-agri.cn/prod/api/resources/user/637/20230727_181252_03a617c1b066/%E5%9B%BE%E7%89%871.png",
    "branchName": "党委机关党支部",
    "positionName": "村党委书记  村委会主任",},{
        "id": 2,
    "memberName": "李永刚",
    "avatarUrl": "https://xiaopingfang.baize-agri.cn/prod/api/resources/user/637/20230727_181324_67c3e0009d0b/图片2.png",
    "branchName": "党委机关党支部",
    "positionName": "村党委副书记",}]
    }
  },
  methods: {
    goHome() {
      this.$router.replace('/')
    },
    getTime() {
      this.timer = setInterval(() => {
        let timeDate = new Date()
        let year = timeDate.getFullYear()
        let mounth = timeDate.getMonth() + 1
        let day = timeDate.getDate()
        let hours = timeDate.getHours()
        hours = hours >= 10 ? hours : '0' + hours
        let minutes = timeDate.getMinutes()
        minutes = minutes >= 10 ? minutes : '0' + minutes
        let seconds = timeDate.getSeconds()
        seconds = seconds >= 10 ? seconds : '0' + seconds
        let week = timeDate.getDay()
        let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

        this.nowTime = `${year}年${mounth}月${day}日  ${weekArr[week]} ${hours}:${minutes}:${seconds}`
      }, 1000)
    },

    initChart() {
      let chart = echarts.init(this.$refs.renkou, null, { renderer: 'svg' })
      chart.clear()
      chart.setOption(barOptions)

      // 地图绘制
      // { geoJSON: mapData }
      echarts.registerMap('xiaopingfang', mapData)
      let map = echarts.init(this.$refs.mapBox, null, { renderer: 'svg' })
      map.clear()
      map.setOption(mapOption)
    },
    autoRoll(stop) {
      if (stop) {
        clearInterval(this.rolltimer)
        return
      }
      const table = this.$refs.tab
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.rolltimer)
      } else {
        this.rolltimer = setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1
          if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
            divData.scrollTop = 0
          }
        }, 50) // 滚动速度
      }
    },
    getResidents(regionId) {
      this.zpajList = []
      getAllGrids({ regionId: 50, isEncrypt: 1 }).then(res => {
        if (res.code == '0') {
          res.model.map(item => {
            if (item.avatarUrl) item.avatarUrl = 'https://xiaopingfang.baize-agri.cn/prod/api' + item.avatarUrl
          })
          this.zpajList = res.model
          // console.log(this.zpajList)

          this.autoRoll()
        } else {
        }
      })
    },
    filterArr(list) {
      let arr = list
      let data = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].detailList && arr[i].detailList.length) {
          arr[i].detailList.map(item => {
            if (item?.elementValue) {
              item.elementValue = JSON.parse(item.elementValue)
              if (item.elementValue.elementType == 'morelines' && ['种植', '养殖'].includes(arr[i].title)) {
                if (item.elementValue.yAxisData.length) {
                  item.elementValue.yAxisData.forEach(dataItem => {
                    if (dataItem.tagData.length) {
                      dataItem.tagData.map(ii => {
                        if (ii?.num != undefined) {
                          dataItem.data.push(ii.num)
                        }
                      })
                      dataItem.type = arr[i].title
                      data.push(dataItem)
                    }
                  })
                }
              }
            }
          })
        }
      }
      return data
    },
    //菜单详情
    getDetatils(stid, parentId) {
      this.dataList = []
      getOthers({ stId: stid, parentId: '' }).then(res => {
        if (res.code == '0') {
          this.dataList = this.filterArr(res.model)
          this.data1List = [
            { type: '工矿', name: '万昆矿业', data: [7500, 7215, 8000] },
            { type: '工矿', name: '铁矿', data: [2432, 2967, 3000] },
            { type: '企业', name: '秀源', data: [1450, 1420, 1500] },
            { type: '企业', name: '泰达砖厂', data: [1800, 2000, 2000] },
            { type: '企业', name: '永山车队', data: [90, 120, 150] }
          ]
          // { type: '服务业', name: '净月溪', data: [100, 206, 187] },
          this.data2List = [{ type: '服务业', name: '天秀山', data: [17, 22, 32] }, { type: '服务业', name: '广源', data: [8000, 8000, 10000] }]
          this.$nextTick(() => {
            this.drowLines('nong')
          })
        }
      })
    },
    drowLines(type) {
      if (type == 'nong') {
        let currindex = 0
        this.linetimer = setInterval(() => {
          let item = this.dataList[currindex]
          this.zhong = item.type == '种植' ? true : false
          this.yang = item.type == '养殖' ? true : false
          let unit = '万斤'
          if (item.type == '养殖') {
            if (['鸡', '羊'].includes(item.name)) {
              unit = '只'
            } else if (['猪', '牛', '毛驴', '驴'].includes(item.name)) {
              unit = '头'
            }
          }
          newlineOption.series[0].data = item.data
          newlineOption.yAxis.name = item.name + '（' + unit + '）'

          let linenew = echarts.init(this.$refs.linenew, null, { renderer: 'svg' })
          linenew.clear()
          linenew.setOption(newlineOption)
          if (currindex == this.dataList.length - 1) {
            currindex = 0
            return
          }
          currindex++
        }, 6000)
      }
      // 工业
      if (this.data1List.length) {
        let currindex1 = 0
        this.gtimer = setInterval(() => {
          let item = this.data1List[currindex1]
          this.kuang = item.type == '工矿' ? true : false

          newlineOption.series[0].data = item.data
          newlineOption.yAxis.name = item.name + '（万元）'

          let linenew1 = echarts.init(this.$refs.linenew1, null, { renderer: 'svg' })
          linenew1.clear()
          linenew1.setOption(newlineOption)
          if (currindex1 == this.data1List.length - 1) {
            currindex1 = 0
            return
          }
          currindex1++
        }, 6000)
      }
      // 服务业
      if (this.data2List.length) {
        let currindex2 = 0
        this.ftimer = setInterval(() => {
          let item = this.data2List[currindex2]
          let unit1 = '万元'
          if (item.name == '广源') {
            unit1 = '人'
          }
          newlineOption.series[0].data = item.data
          newlineOption.yAxis.name = item.name + '（' + unit1 + '）'

          let linenew2 = echarts.init(this.$refs.linenew2, null, { renderer: 'svg' })
          linenew2.clear()
          linenew2.setOption(newlineOption)
          if (currindex2 == this.data2List.length - 1) {
            currindex2 = 0
            return
          }
          currindex2++
        }, 6000)
      }
    },
    getRatio() {
      getAllRatio().then(res => {
        if (res.code == '0') {
          this.baseParams = res.model.resByCou[0]
          circleOption.series[0].data = res.model.resByAge
          this.$nextTick(() => {
            let circle = echarts.init(this.$refs.circle, null, { renderer: 'svg' })
            circle.clear()
            circle.setOption(circleOption)
          })
        }
      })
    },
    //村委班子
    getMembers() {
      this.peopleList = []
      getAllMembers({ partyFlag: 1 }).then(res => {
        if (res.code == '0') {
          res.model.forEach(item => {
            if (item.avatarUrl) item.avatarUrl = 'https://xiaopingfang.baize-agri.cn/prod/api' + item.avatarUrl
          })
          this.peopleList = res.model
          console.log(this.peopleList)
        }
      })
    },
    getPartyTable(villageId) {
      this.morePeoples = []
      getDangArea({ villageId: 50 }).then(res => {
        if (res.code == '0') {
          // if (res.model.length > 0) {
          //   res.model.map(i => {
          //     i.articleContent = i.branchText
          //     i.name = i.branchName
          //     i.type = 'party'
          //   })
          this.morePeoples = res.model
          // }
        }
      })
    }
  },
  mounted() {
    this.getTime()
    this.initChart()
    //查询网格员
    this.getResidents()
    //村委班子
    this.getDetatils(19)
    this.getRatio()
    // 村委
    this.getMembers()
    // 党委
    this.getPartyTable()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.autoRoll('stop')
    if (this.linetimer) clearInterval(this.linetimer)
    if (this.gtimer) clearInterval(this.gtimer)
    if (this.ftimer) clearInterval(this.ftimer)
  }
}
</script>
<style lang="scss" scope>
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  font-size: 56.5833px;
}
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
*,
:after,
:before {
  box-sizing: border-box;
}
ol,
ul {
  padding-left: 0;
  list-style-type: none;
  margin: 0;
}
@font-face {
  font-family: 'HuXiaoBoNanShenTi';
  src: url('./assets/fonts/HuXiaoBoNanShenTi-2.otf') format('truetype');
}
.largeScreen {
  width: 100vw;
  height: 100vh;
  background: url('./assets/img/data-bg.png') no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  .top {
    height: 12vh;
    background: url('./assets/img/bg_title.png') no-repeat;
    background-size: 100% 100%;
    .topVue {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      height: 100%;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      .left,
      .right {
        flex: 1;
      }
      .left {
        font-size: 0.18rem;
        color: hsla(0, 0%, 100%, 0.6);
        padding-left: 0.2rem;
        padding-bottom: 0.3rem;
        cursor: pointer;
      }
      .center {
        flex: 3;
      }
      .title {
        text-align: center;
        font-size: 0.46rem;
        color: #fff;
        font-family: HuXiaoBoNanShenTi;
        letter-spacing: 0.08rem;
      }
      .right {
        text-align: right;
        padding-right: 0.2rem;
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 0.18rem;
        padding-bottom: 0.3rem;
        margin-left: 0.2rem;
      }
    }
  }
  // 主体
  .cont {
    height: 88vh;
    display: flex;
    padding: 0 0.2rem 0.2rem;
    box-sizing: border-box;
    // 左侧
    .contLeft {
      flex: 1.2;
      position: relative;
      background: url('./assets/img/bg_person_statistics.png') no-repeat;
      background-size: 100% 100%;
      padding: 0.03rem 0.2rem 0.1rem;
      .CL_title {
        position: absolute;
        top: -0.25rem;
        left: 0;
      }

      .CL_cont {
        height: 100%;
      }
      .CL_cont1,
      .CL_cont2,
      .CL_cont3 {
        padding-top: 0.1rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
      }
      .CL_cont1 {
        height: 24%;
      }
      .CL_cont2 {
        height: 40%;
        position: relative;
      }
      .CL_cont3 {
        height: 36%;
      }
      .CL_cont1 .smallTitle,
      .CL_cont2 .smallTitle,
      .CL_cont3 .smallTitle {
        color: #fff;
        font-family: HuXiaoBoNanShenTi;
        font-size: 0.15rem;
        -webkit-box-shadow: inset 2px 0 0 0 #385abb;
        box-shadow: inset 2px 0 0 0 #385abb;
        padding: 0.03rem 0.06rem;
        letter-spacing: 0.02rem;
        position: relative;
        z-index: 1;
      }
      .CL_cont1 .smallCont,
      .CL_cont2 .smallCont,
      .CL_cont3 .smallCont {
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
      }
      .CL_cont1 .fade3,
      .CL_cont2 .fade3,
      .CL_cont3 .fade3 {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: linear-gradient(90deg, rgba(56, 90, 187, 0.36), rgba(56, 90, 187, 0));
        z-index: -1;
      }
    }
    // 中间
    .contCenter {
      flex: 4.02;
      margin: 0 0.2rem;
      .CC_top {
        height: 66%;
        .mapCont {
          height: 100%;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          .info {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            margin: 0.1rem 0;
            overflow: hidden;
            // position: relative;
            background: url('./assets/img/Group-540.png') no-repeat;
            background-size: 100% 100%;

            .infoTitle {
              color: #fff;
              font-family: HuXiaoBoNanShenTi;
              font-size: 0.45rem;
              padding: 0.2rem 0.25rem;
              position: relative;
              white-space: nowrap;
              letter-spacing: 0.2rem;
              text-align: center;
            }
            .infoCont {
              padding-top: 0.15rem;
              height: calc(100vh - 55vh);
              color: #fff;
              padding-left: 0.26rem;
              font-size: 0.16rem;
              overflow-y: scroll;
              width: 90%;
              margin: 0.65rem auto 0;
              .infoCount_item {
                display: flex;
                margin-bottom: 0.15rem;
                img {
                  width: 1rem !important;
                  margin-right: 0.2rem;
                }
              }
            }
            .infoCont::-webkit-scrollbar {
              /*滚动条整体样式*/
              width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
              height: 1px;
            }
            .infoCont::-webkit-scrollbar-thumb {
              /*滚动条里面小方块*/
              border-radius: 10px;
              box-shadow: inset 0 0 5px #0d53b7;
              -webkit-box-shadow: inset 0 0 5px #0d53b7;
              background: #535353;
            }
            .infoCont::-webkit-scrollbar-track {
              /*滚动条里面轨道*/
              border-radius: 10px;
              background: transparent;
            }
          }
          // .info:before {
          //   content: '';
          //   display: inline-block;
          //   position: absolute;
          //   left: 0;
          //   bottom: 0;
          //   width: 100%;
          //   height: 100%;
          //   background: url('./assets/img/Group-540.png') no-repeat;
          //   background-size: 100% 100%;
          //   // -webkit-animation: yang .8s linear 0s;
          //   // animation: yang.8s linear 0s;
          // }
          .mapCity {
            -webkit-box-flex: 1.4;
            -ms-flex: 1.4;
            flex: 1.4;
          }
        }
      }
      .CC_Bottom {
        height: 34%;
        padding-top: 0.1rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        .CCB1,
        .CCB2,
        .CCB3 {
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          overflow: hidden;
        }
      }
    }
    .contRight {
      flex: 1.25;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      // width: 20%;
      .CR1,
      .CR2,
      .CR3 {
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
      }
      .CR1 {
        height: 27%;
        position: relative;
        top: -0.25rem;
      }
      .CR2 {
        height: 39%;
        padding-bottom: 0.1rem;
        margin-top: -0.2rem;
      }
      .CR3 {
        height: 34%;
        padding-top: 0.1rem;
      }
      .CR1 .CR_cont,
      .CR2 .CR_cont,
      .CR3 .CR_cont {
        -webkit-box-flex: 1;
        flex-grow: 1;
      }
      .CR_cont {
        .content {
          width: 50%;
          height: 100%;
          margin: 0 auto;
          cursor: pointer;
          position: relative;
          transform-style: preserve-3d;
          animation: rotate 20s linear infinite;
        }
        // .content:hover {
        //     animation-play-state: paused;
        // }

        .content img {
          width: 150px;
          height: 100px;
        }

        .content div {
          position: absolute;
          left: 0;
          top: 0;
          width: 150px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          /* 通过html5的-webkit-box-reflect来做倒影 */
          /* box-reflect属性值有：dirrection-方向:above向上，below向下，left向左，right向右。
            offset距离：可以是数值，也可以是百分比： mask-box-image设置倒影的遮罩图像：（1）url（2）linear-gradient线性渐变创建遮罩图像。（3）repeating-linear-gradient重复线性渐变创建遮罩图像。（4）repeating-url重复径向径向渐变创建遮罩图像。
        */
          -webkit-box-reflect: below 15px linear-gradient(transparent 10%, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3));
        }

        .content div:nth-child(1) {
          transform: translateZ(150px);
          // background-color: #c14c39;
        }

        .content div:nth-child(2) {
          transform: rotateY(60deg) translateZ(150px);
          // background-color: #6e9c72;
        }

        .content div:nth-child(3) {
          transform: rotateY(120deg) translateZ(150px);
          // background-color: #5e5f7a;
        }

        .content div:nth-child(4) {
          transform: rotateY(180deg) translateZ(150px);
          // background-color: #f5eb98;
        }

        .content div:nth-child(5) {
          transform: rotateY(240deg) translateZ(150px);
          // background-color: #50a3bc;
        }

        .content div:nth-child(6) {
          transform: rotateY(300deg) translateZ(150px);
          // background-color: #f9a99a;
        }
        @keyframes rotate {
          0% {
            transform: rotateY(0);
          }

          100% {
            transform: rotateY(360deg);
          }
        }
      }
    }

    .CCB1 .CCBCont,
    .CCB2 .CCBCont,
    .CCB3 .CCBCont,
    .CR3 .CCBCont {
      -webkit-box-flex: 1;
      flex-grow: 1;
    }
    .abnormalAlarm {
      width: 100%;
      height: 100%;
      padding-top: 0.1rem;
      p {
        background-color: rgba(72, 121, 223, 0.2);
        color: #fff;
        display: flex;
        justify-content: space-between;
        height: 0.3rem;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-box-align: center;
        span {
          flex: 1;
          text-align: center;
          font-size: 0.12rem;
        }
      }

      .realData {
        height: calc(100% - 0.4rem);
        overflow: hidden;
        color: #fff;
      }

      p:first-child,
      p:nth-child(2) {
        flex: 0.8 !important;
      }
      p:nth-child(3) {
        flex: 1 !important;
      }
      p:nth-child(4),
      p:nth-child(5) {
        flex: 1.5 !important;
      }
    }
  }
}
.bigTitle {
  color: #fff;
  font-family: HuXiaoBoNanShenTi;
  font-size: 0.18rem;
  letter-spacing: 0.02rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  .beforeSpanBox {
    width: 0.5rem;
    height: 0.2rem;
    position: relative;
  }
  .beforeSpan {
    top: 0;
    position: absolute;
    display: inline-block;
    width: 0.2rem;
    height: 0.2rem;
    transform: rotate(45deg) skew(170deg, 170deg);
    background: linear-gradient(45deg, rgba(56, 90, 187, 0) 50%, rgba(5, 241, 193, 1) 100%);
  }
  .beforeSpan3 {
    left: -0.1rem;
  }
  .beforeSpan1 {
    left: 0.1rem;
  }
  .beforeSpan2 {
    left: 0;
  }
  .afterSpan {
    position: relative;
    margin-left: 0.2rem;
    flex-grow: 1;
    height: 0.03rem;
    background: linear-gradient(270deg, rgba(56, 90, 187, 0), rgba(28, 141, 163, 1));
  }
  .afterSpan:before {
    content: '';
    position: absolute;
    width: 0.1rem;
    height: 0.1rem;
    display: inline-block;
    background-color: #1c8aa2;
    top: 50%;
    left: 0;
    -webkit-transform: translateY(-50%) rotate(45deg);
    transform: translateY(-50%) rotate(45deg);
  }
}

//动画部分
.fade-enter,
.fade-leave-to,
.fade1-enter,
.fade1-leave-to,
.fade2-enter,
.fade2-leave-to,
.fade3-enter,
.fade3-leave-to {
  opacity: 1;
}
.fade1-enter-active,
.fade1-leave-active {
  animation: yang1 1s;
  animation-iteration-count: infinite;
}
.fade2-enter-active,
.fade2-leave-active {
  animation: yang2 1s;
  animation-iteration-count: infinite;
}

.fade-enter-active,
.fade-leave-active {
  animation: yang 1s;
  animation-iteration-count: infinite;
}
.fade3-enter-active,
.fade3-leave-active {
  animation: yang3 1s;
  animation-iteration-count: infinite;
}
@keyframes yang {
  0% {
    margin-left: 45%;
  }
  100% {
    margin-left: 0.2rem;
  }
}
@keyframes yang1 {
  0% {
    left: -0.1rem;
  }
  100% {
    left: 0.1rem;
  }
}
@keyframes yang2 {
  0% {
    left: -0.1rem;
  }
  100% {
    left: 0;
  }
}
@keyframes yang3 {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

// 性别比例
.sexVue .sexLegend .sexBox,
.sexVue .sexLegend,
.sexVue {
  display: flex;
}
.sexVue {
  width: 100%;
  height: 100%;
  color: #b7cbff;
  font-size: 0.12rem;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-top: 0.5vh;
  .sexLegend {
    .sexBox > span {
      color: #fff;
      font-size: 0.18rem;
      margin-right: 0.1rem;
    }
    .sexBox {
      margin-right: 0.2rem;
      .sexNum {
        font-size: 0.2rem;
        color: #fff;
      }
      .sexLabel {
        font-size: 0.12rem;
        margin-left: 0.1rem;
      }
    }
  }
  .sexEcharts {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    .man,
    .woman {
      height: 0.22rem;
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: flex-end;
    }
    .man {
      transform: translateX(-0.4rem);
      .manDiv {
        background-color: #00aeff;
        -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0.5rem 0);
      }
    }
    .man .manDiv,
    .man .womanDiv,
    .woman .manDiv,
    .woman .womanDiv {
      height: 100%;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
    }
    .woman .womanDiv {
      background-color: #fac858;
      -webkit-clip-path: polygon(100% 0, calc(100% - 0.5rem) 100%, 0 100%, 0 0);
    }
    .manDialog,
    .womanDialog {
      position: absolute;
      bottom: 0.16rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    .manDialog:before,
    .womanDialog:before {
      display: inline-block;
      content: '';
      position: absolute;
      background-image: url('./assets/img/label.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
    }
    .manDialog span:first-child,
    .womanDialog span:first-child {
      padding: 0.03rem 0 0;
      white-space: nowrap;
    }
    .manDialog span:nth-child(2),
    .womanDialog span:nth-child(2) {
      padding: 0 0.03rem 0.12rem;
      white-space: nowrap;
    }
    .manDialog {
      right: 0;
    }
    .manDialog:before {
      transform: rotateY(180deg);
    }
  }
}

.echartsEl,
.population {
  width: 100%;
  height: 100%;
}
.ageVue {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.echartsBg {
  position: absolute;
  width: 60%;
  height: 100%;
  .span1,
  .span2 {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .span1 {
    width: 63%;
    padding: 63% 0 0;
    background: url('./assets/img/bg_age_1.png') no-repeat;
    background-size: 100% 100%;
    -webkit-animation: changDeg1 2s linear 0.2s infinite;
    animation: changDeg1 2s linear 0.2s infinite;
  }
  .span2 {
    width: 67%;
    padding: 67% 0 0;
    background: url('./assets/img/bg_age_2.png') no-repeat;
    background-size: 100% 100%;
    -webkit-animation: changDeg2 2s linear 0.2s infinite;
    animation: changDeg2 2s linear 0.2s infinite;
  }
  .span3 {
    width: 70%;
    padding: 70% 0 0;
    background: url('./assets/img/bg_age_2.png') no-repeat;
    background-size: 100% 100%;
    -webkit-animation: changDeg1 2s linear 0.2s infinite;
    animation: changDeg1 2s linear 0.2s infinite;
  }
  .span4 {
    width: 73%;
    padding: 73% 0 0;
    background: url('./assets/img/bg_age_3.png') no-repeat;
    background-size: 100% 100%;
    -webkit-animation: changDeg2 2s linear 0.2s infinite;
    animation: changDeg2 2s linear 0.2s infinite;
  }
  @keyframes changDeg1 {
    0% {
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      -webkit-transform: translate(-50%, -50%) rotate(1turn);
      transform: translate(-50%, -50%) rotate(1turn);
    }
  }
  @keyframes changDeg2 {
    0% {
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
      transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
      -webkit-transform: translate(-50%, -50%) rotate(-1turn);
      transform: translate(-50%, -50%) rotate(-1turn);
    }
  }
}

.energyStatistics {
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 0.25rem;
  position: relative;
  .left {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    // justify-content: space-between;
    justify-content: space-evenly;
    margin-right: 0;
    .leftbox {
      height: 31%;
      background: url('./assets/img/ic_water.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      color: #fff;
      .lb_left {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        span {
          font-size: 0.12rem;
        }
      }
      .lb_right {
        -webkit-box-flex: 1.5;
        -ms-flex: 1.5;
        flex: 1.5;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        span {
          font-size: 0.12rem;
        }
      }
    }
  }
  .right {
    -webkit-box-flex: 2.4;
    -ms-flex: 2.4;
    flex: 2.4;
  }
  .active {
    box-shadow: 5px 6px 12px 0px #83bff6;
  }
}

// table样式

.realData .el-table th.el-table__cell {
  background-color: rgba(72, 121, 223, 0.2) !important;
  color: #fff !important;
  height: 0.3rem !important;
}
.realData .el-table .el-table__cell {
  padding: 0 !important;
  height: 0.3rem !important;
  font-size: 0.12rem;
}
.realData .el-table thead {
  color: #fff !important;
  font-size: 0.12rem !important;
}
.realData > .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
.realData .el-table tr {
  color: #fff !important;
  background: rgba(72, 121, 223, 0.2) !important;
}
.realData .el-table tr:nth-child(odd) {
  background: hsla(1, 0%, 88.2%, 0) !important;
}
/* 用来设置当前页面element全局table 选中某行时的背景色*/
.realData .el-table__body tr.current-row > td {
  background-color: inherit !important;
  /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
}
/* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
.realData .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: inherit !important;
  /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
}
.realData .el-table__body-wrapper {
  overflow: hidden !important;
}
.realData .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border: none !important;
}
.realData .el-table__body,
.el-table__footer,
.el-table__header {
  width: 100% !important;
}

.cunInfo {
  margin: 1rem 0 0 0.3rem !important;
  height: calc(100vh - 63vh) !important;
  width: 85% !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  .infoCount_item {
    flex-direction: column;
    align-items: flex-start;
  }
}
.overflow-ellipsis-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 1rem;
  height: 0.62rem;
}
</style>